module.exports = __webpack_public_path__ + "img/bank_img3.36e3a50f.png";